import { LandingPageData } from './interfaces/landing-page.types';

/**
 * Landing pages SEO comerciales/locales — registro dinámico por cliente.
 *
 * Cada entrada agregada aquí queda disponible automáticamente en '/<slug>':
 * ruta pública, meta SEO (title/description/canonical/robots/OG), JSON-LD
 * (BreadcrumbList + FAQPage si hay `faq`), entrada en sitemap.xml y ruta de
 * prerender — sin tocar app.routes.ts ni ningún script de build.
 * Ver src/app/pages/public/landing/landing.component.ts (motor, homologado)
 * y src/app/shared/landing-page.matcher.ts.
 *
 * No uses un `slug` igual a una ruta fija del sitio (about, contact, services,
 * team, gallery, location, publications, login, register, product, etc.):
 * la ruta fija siempre gana y la landing page quedaría inalcanzable.
 */
export const CUSTOM_LANDING_PAGES: LandingPageData[] = [
  /* BEGIN | CUSTOM LANDING PAGES — agregar una entrada por página SEO local/comercial */
  /*
  {
    slug: 'rent-a-car-punta-arenas',
    title: 'Rent a Car en Punta Arenas | Alto Paine',
    description: 'Arrienda tu vehículo en Punta Arenas con entrega en aeropuerto. Sedanes, SUV y 4x4 para recorrer la Patagonia con Alto Paine Rent a Car.',
    h1: 'Rent a Car en Punta Arenas',
    badge: 'Punta Arenas',
    intro: '<p>Punta Arenas es el punto de partida ideal para recorrer la Patagonia chilena y argentina...</p>',
    breadcrumbLabel: 'Punta Arenas',
    index: true,
    sections: [
      {
        heading: '¿Por qué arrendar en Punta Arenas con Alto Paine?',
        level: 2,
        html: '<p>...</p>'
      }
    ],
    faq: [
      { question: '¿Entregan vehículos en el aeropuerto?', answer: 'Sí, coordinamos la entrega directamente en el aeropuerto de Punta Arenas.' }
    ],
    relatedLinks: [
      { label: 'Torres del Paine', path: '/rent-a-car-torres-del-paine' },
      { label: 'Guía para recorrer la Patagonia en auto', path: '/publications/guia-patagonia-en-auto-12' }
    ],
    cta: {
      heading: '¿Listo para recorrer la Patagonia?',
      text: 'Cotiza tu vehículo y recíbelo directamente en el aeropuerto de Punta Arenas.',
      buttonLabel: 'Cotiza tu vehículo',
      buttonPath: '/services'
    }
  },
  */
  /* END | CUSTOM LANDING PAGES */
];
